(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/redbeemedia/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/redbeemedia/assets/javascripts/init.js');

'use strict';

svs.components.redbee_video_player.initVideo = function () {
  var rootElements = document.querySelectorAll('.js-redbee-media-media-container[data-asset-id]');
  Array.from(rootElements).forEach(function (rootElement) {
    var Thumbnail = svs.components.redbee_video_player.Thumbnail;
    var _rootElement$dataset = rootElement.dataset,
      assetId = _rootElement$dataset.assetId,
      businessUnit = _rootElement$dataset.businessUnit,
      customer = _rootElement$dataset.customer;
    delete rootElement.dataset.asset;
    ReactDOM.render( React.createElement(Thumbnail, {
      assetId: assetId,
      businessUnit: businessUnit || 'VOD',
      customer: customer || 'SvenskaSpel'
    }), rootElement);
  });
};
setTimeout(function () {
  svs.components.redbee_video_player.initVideo();
}, 500);

 })(window);